import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ProgressBar } from 'react-bootstrap'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { Link, Redirect } from 'react-router-dom'
import { resetTransactionDetails } from '../../smartContract/stakeAction'

function TransactionCompleted() {
  const { transactionDetails } = useSelector((state) => state.stake)

  const dispatch = useDispatch()

  const redirectToDashboard = () => {
    dispatch(resetTransactionDetails())
  }

  const now = 60
  const progressInstance = (
    <ProgressBar className="blue_prgrss" now={now} label={`${now}%`} />
  )

  if (!transactionDetails.TransactionId) {
    return <Redirect to="/dashboard" />
  }

  return (
    <div className="row">
      <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap db_1400">
        <div className="mr-1">
          <h5 className="inpg_ttl">QRFID Gold</h5>
        </div>
      </div>

      <div className="col-md-12 mt-5">
        <div class="shadow_box">
          <div class="row justify-content-center">
            <div class="col-xl-7 aspr-0 mb-5">
              <div class="pd-40">
                <div class="row">
                  <div className="col-md-12 text-center">
                    <img
                      alt="Logo"
                      className="mb-5"
                      src={toAbsoluteUrl(
                        '/media/others/transaction_completed_img.png',
                      )}
                    />
                  </div>
                  <div className="col-md-12 text-center mt-4 mb-15">
                    <h3 className="fn_s_26 f-w-400 color_blue">
                      Transaction Completed
                    </h3>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Purchased Gold
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {transactionDetails.grams} GMS
                    </h4>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Amount
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {transactionDetails.amount} USD
                    </h4>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Tokens
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {transactionDetails.tokens}
                    </h4>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Transaction Date
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {new Date(transactionDetails.createdAt).toLocaleString()}
                    </h4>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Transaction ID
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {transactionDetails.TransactionId}
                    </h4>
                  </div>
                  <div class="col-xl-4 col-sm-6 mb-8 text-center">
                    <label class="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                      Payment By
                    </label>
                    <h4 className="fn_s_22 f-w-500 color_blk">
                      {transactionDetails.paymentMethod}
                    </h4>
                  </div>
                  <div className="col-md-12 mt-10 text-center">
                    <button
                      onClick={redirectToDashboard}
                      class="btn btn-def btn-defv5 uppercase .btn-link"
                    >
                      Back to List
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionCompleted
